import React, { useState } from "react";

import useMetaSearch from "../../../shared/hooks/useMetaSearch";
const imageDefault = require("../../../assets/images/author-default.jpeg");

import "./input.scss";

interface AuthorProps {
  imageUrl: string;
  title: string;
  value: string;
  handler?: any;
}

const Author = (props: AuthorProps) => {
  const handleName = () => {
    if (props.title.indexOf(props.value) === -1 && props.title.length !== props.value.length) {
      return;
    } else if (props.title.indexOf(props.value) === 0) {
      return (
        <p className="a-input__authors-author__name">
          <span className="blacked">
            {props.title.slice(props.title.indexOf(props.value), props.value.length)}
          </span>
          {props.title.slice(props.value.length)}
        </p>
      )
    } else if ((props.title.indexOf(props.value) + props.value.length) === props.title.length) {
      return (
        <p className="a-input__authors-author__name">
          {props.title.slice(0, props.title.indexOf(props.value))}
          <span className="blacked">
            {props.title.slice(props.title.indexOf(props.value))}
          </span>
        </p>
      )
    } else if (props.title.length === props.value.length) {
      return (
        <p className="a-input__authors-author__name">
          <span className="blacked">
            {props.title}
          </span>
        </p>
      )
    } else {
      return (
        <p className="a-input__authors-author__name">
          {props.title.slice(0, props.title.indexOf(props.value))}
          <span className="blacked">
            {
            props.title.slice(props.title.indexOf(props.value), (props.title.indexOf(props.value) + props.value.length))
            }
          </span>
          {
            props.title.slice(props.title.indexOf(props.value) + props.value.length)
          }
        </p>
      )
    }

  }

  return (
    <div className="a-input__authors-author" onClick={props.handler}>
      {
        handleName()
      }
    </div>
  );
};

interface InputProps {
  cardsInfo: any;
  handleSelection?: any;
  readonly?: boolean;
  isSelected?: any;
  disableSelection?: any;
}

const Input = (props: InputProps) => {
  const [readOnly, setReadOnly] = useState(false);
  const [value, setValue] = useState("");
  const [classInput, setClassInput] = useState("default");
  const { metaSearch } = useMetaSearch("autores");
  let authors = metaSearch?.length ? metaSearch : null;

  const inputHandler = (event) => setValue(event.target.value);

  const selectionHandler = (name, closeSelected = false) => {
    let event = {
      target: { alt: name },
    };

    if (closeSelected) {
      return props.handleSelection(event, closeSelected);
    }

    props.handleSelection(event, closeSelected);
    setValue(name.slice(0, 30) + "...");

    setClassInput(closeSelected ? "default" : "selection");
  };

  const normalize = (string) => {
    return (
      string.normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase())
  }

  return (
    <div className="a-input">
      <input
        className={`a-input__box ${
          value.length > 0 ? "a-input__box--filled" : ""
        } ${classInput === "selection" ? "a-input__box--selection" : ""}`}
        placeholder="Escribe el nombre de tu autor"
        onChange={inputHandler}
        value={value}
        readOnly={readOnly}
        maxLength={30}
      />
      <div
        className={`a-input__authors ${
          value.length === 0 || classInput === "selection"
            ? ""
            : "a-input__authors--filled"
        }`}
      >
        {authors
          ?.filter((elem) => {
            let copyAuthor = normalize(elem.autor)
            let valueArr = value.split(" ");

            for (let i = 0; i < valueArr.length; i++) {
              if (
                elem &&
                value.length > 4 &&
                copyAuthor.includes(normalize(valueArr[i]))
              ) {
                continue;
              } else {
                return false;
              }
            }

            return true;
          })
          .sort((a, b) => a.length - b.length)
          .map((elem, idx) => {
            if (idx < 20) {
              return (
                <Author
                  key={idx}
                  imageUrl={imageDefault}
                  title={normalize(elem.autor)}
                  value={normalize(value)}
                  handler={() => {
                    setReadOnly(true);
                    selectionHandler(elem.autor);
                  }}
                />
              );
            }
          })}
      </div>

      <div
        className={`a-input__line ${
          value.length === 0 || classInput === "selection"
            ? ""
            : "a-input__line--show"
        }`}
      ></div>

      <div
        className={`a-input__close ${
          value.length === 0 ? "" : "a-input__close--show"
        }`}
        onClick={() => {
          setValue("");
          setReadOnly(false);
          props.disableSelection(-1);
          props.isSelected(false);
          selectionHandler("", true);
          setClassInput("default");
        }}
      >
        <div className="icon-close"></div>
      </div>
    </div>
  );
};

export default Input;
